import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSFaq,
  CMSHowToParticipate,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';

export interface BonanzaPromoImageByStatus {
  promoStatus: string;
  image: CMSImageBase;
}

export interface BonanzaPromoMenuDataApi extends CMSApiBase {
  menu: {
    bg: CMSImageBase;
    unloggedCharacter: CMSImageBase;
    returnToStartFresh: string;
    claimBonus: string;
    yourProgress: string;
    yourReward: string;
    charactersByStatus: BonanzaPromoImageByStatus[];
  };
}

export const bonanzaPromoMenuCMS = (lang: string) =>
  request<BonanzaPromoMenuDataApi>({
    url: buildCmsUrl({
      path: 'bonanza-promo',
      lang,
      additionalParams: {
        'populate[0]': 'menu',
        'populate[1]': 'menu.bg',
        'populate[2]': 'menu.unlogged_character',
        'populate[3]': 'menu.characters_by_status',
        'populate[4]': 'menu.characters_by_status.image',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<BonanzaPromoMenuDataApi>
    ),
  });

export interface BonanzaPromoDataApi extends BonanzaPromoMenuDataApi {
  bg: CMSImageBase;
  titleImg: CMSImageBase;
  description: string;
  congratulations: string;
  enjoyYourPlay: string;
  bonanzaStatus: BonanzaPromoImageByStatus[];
  howToParticipateTitle: string;
  howToParticipate: CMSHowToParticipate[];
  faq: CMSFaq[];
}

export const bonanzaPromoCMS = (lang: string) =>
  request<BonanzaPromoDataApi>({
    url: buildCmsUrl({
      path: 'bonanza-promo',
      lang,
      additionalParams: {
        populate: 'deep',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<BonanzaPromoDataApi>
    ),
  });
